<template>
  <div style="width: 100%">
    <v-row class="align-center" style="margin-left: 16px;">
      <v-col md="3" class="hidden-sm-and-down pb-4">
        <span class="topbar-title">{{ $t($route.meta.title) }}</span>
      </v-col>
      <v-col md="9" class="d-flex align-center justify-end flex-grow-1">
      </v-col>
    </v-row>
    <v-container
      class="kbd"
      v-if="!$vuetify.breakpoint.smAndDown"
      ref="keyboard"
      v-show="oskVisible"
      :style="{ 'max-width': width }"
    >
      <div class="kbd-header"></div>
      <vue-touch-keyboard
        :options="oskOptions"
        :layout="layout"
        :cancel="hideKbd"
        :accept="accept"
        :input="input"
      />
    </v-container>
  </div>
</template>
<script>
import state from '@/state'
import applicationSettings from '@/mixins/applicationSettings'
import onScreenKeyboard from '@/mixins/onScreenKeyboard'

export default {
  name: 'CompaniesTopBar',
  mixins: [applicationSettings, onScreenKeyboard],
  data: function () {
    return {
      topSearch: '',
      unfiskReceipts: [],
      listeners: []
    }
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
  },
  computed: {
    title () {
      return state.getAppTitle()
    },
    listView () {
      return state.isListView()
    }
  },
  watch: {
    filter (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    },
    search (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    }
  },
  methods: {
    changeView () {
      state.setListView(!state.isListView())
    },
    fireAddEvent () {
      if (state.events && Object.prototype.hasOwnProperty.call(state.events, this.$route.meta.addItemAction)) {
        state.events[this.$route.meta.addItemAction] = true
      }
    },
    searchItems (reset = false) {
      if (reset) {
        this.search = ''
      } else {
        if (this.topSearch) {
          this.search = this.topSearch
        } else {
          this.search = ''
        }
      }
    },
    filterItems (reset = false) {
      if (reset) {
        this.filter = ''
      } else {
        if (this.topSearch) {
          this.filter = this.topSearch
        } else {
          this.filter = ''
          this.search = '' // reset search on input event if there is no text
        }
      }
    }
  }
}
</script>
<style scoped>
/* TopBar Title */
.topbar-title {
  font-size: 22px !important;
  font-weight: 700 !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
}

/* Glass Add Button - Soft Shadow Style */
.glass-add-btn {
  background: #00BCD4 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 8px 16px !important;
  height: 36px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-add-btn:hover {
  background: #00ACC1 !important;
  box-shadow: 0 4px 14px rgba(0, 188, 212, 0.45) !important;
  transform: translateY(-1px);
}

.glass-add-btn .v-icon {
  font-size: 18px !important;
  color: #ffffff !important;
}
</style>
